import { components, DropdownIndicatorProps } from 'react-select';
import { Lock } from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';
import Icon from 'components/Icon/Icon';

const DisabledDropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon svg={Lock} size={16} color={COLORS.BLACK} />
    </components.DropdownIndicator>
  );
};

export default DisabledDropdownIndicator;
